<template>
    <div class="q-my-md">
        <div class="container">
            <h1 class="row-group-title" v-html="title"></h1>
        </div>

        <v-row v-for="(row, i) in rows" :key="i" :is-video="isVideo"
               :title="row.title" :uri="row.uri" :layout="row.layout" :items="isType(type, row)"/>
    </div>
</template>

<script>
    export default {
        name: 'VRowGroup',

        props: {
            title: {
                type: String,
                required: false
            },
            rows: {
                type: Array,
                required: false
            },
            type: String,
            isVideo: Boolean,
            isHome: Boolean
        },
        methods: {
          isType(typeView, row){
              if(typeView === 'now')
                  return row.now
              else if(typeView === 'view')
                  return row.view
              else
                return row.items
          }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/RowGroup.vue